/**
 * NieuweStroom.Trading.Forecast.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LatestForecastResponse { 
    portfolioId?: string;
    portfolioName?: string;
    clusterId?: string;
    clusterName?: string;
    forecasterId?: string;
    forecasterName?: string;
    intradayVersionDb?: string | null;
    intradayTypeDb?: string | null;
    intradayVersionApi?: string | null;
    intradayTypeApi?: string | null;
    modifiedDatabase?: string | null;
    modifiedForecaster?: string | null;
}

